import { generateApiRoute } from '@klp/core/api/helpers';

export const brukerApiName = 'bruker';
const superUserApiName = 'superuser';
const grantApiName = 'grant';
const revokeApiName = 'revoke';
const adminApiName = 'admin';
const customerApiName = 'customer';
export const userApiName = 'user';

export const userApiRoutes = {
    userByToken: () =>
        generateApiRoute([brukerApiName, userApiName, 'bytoken']),
    user: () => generateApiRoute([brukerApiName, userApiName]),
    userSearch: () => generateApiRoute([brukerApiName, 'search']),
    usersForCustomer: (customerNumber: string) =>
        generateApiRoute([brukerApiName, customerApiName, customerNumber]),
    userNotifyWelcome: () =>
        generateApiRoute([brukerApiName, 'notify', 'welcome']),
    userSync: () => generateApiRoute([brukerApiName, 'usersync']),
    adminGrant: (email: string) =>
        generateApiRoute([brukerApiName, adminApiName, grantApiName, email]),
    adminRevoke: (email: string) =>
        generateApiRoute([brukerApiName, adminApiName, revokeApiName, email]),
    superuserGrant: (email: string) =>
        generateApiRoute([
            brukerApiName,
            superUserApiName,
            grantApiName,
            email,
        ]),
    superuserRevoke: (email: string) =>
        generateApiRoute([
            brukerApiName,
            superUserApiName,
            revokeApiName,
            email,
        ]),
    userCustomer: () => generateApiRoute([brukerApiName, customerApiName]),
    userDelete: (email: string) =>
        generateApiRoute([brukerApiName, userApiName, email]),
};
